import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=a402f52e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=a402f52e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a402f52e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a402f52e')) {
      api.createRecord('a402f52e', component.options)
    } else {
      api.reload('a402f52e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=a402f52e&scoped=true&", function () {
      api.rerender('a402f52e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h5g0CW0B5BR2/JS/comp/PopupBox.vue"
export default component.exports